import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useOfferCartOrderData from "./useOfferCartOrderData";
import { UICabinClass } from "@flights/types";
import { useSelector } from "react-redux";
import { getFlight } from "../store/flightDetails/selectors";
import { getOrder } from "../store/order/selectors";

export default function useSearchCabinClass() {
  const location = useLocation();
  const offerCartOrderData = useOfferCartOrderData();
  const flight = useSelector(getFlight);
  const order = useSelector(getOrder);
  const offerToken = useMemo(() => flight?.token, [flight]);
  const orderToken = useMemo(() => order?.orderToken, [order]);

  const searchCabinClass = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const paramCabinClass = (params.get("cabinClass") as UICabinClass) || undefined;
    const storedOfferCabinClass = offerCartOrderData.get(offerToken).cabinClass as UICabinClass | undefined;
    const storedOrderCabinClass = offerCartOrderData.get(orderToken).cabinClass as UICabinClass | undefined;
    return paramCabinClass || storedOfferCabinClass || storedOrderCabinClass;
  }, [offerToken, orderToken, location, offerCartOrderData]);

  return { searchCabinClass };
}
